
// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// const slides = [
//   {
//     id: 1,
//     title: "High-speed Transactions",
//     description:
//       "OwnXChain facilitates high-speed transaction processing with an average TPS of 5000",
//     testnetLink: "/coming-soon",
//     mainnetLink: "/coming-soon",
//     image: "assets/img-1/high-speed-transactions.png",
//   },
//   {
//     id: 1,
//     title: "High-speed Transactions",
//     description:
//       "OwnXChain facilitates high-speed transaction processing with an average TPS of 5000",
//     testnetLink: "/coming-soon",
//     mainnetLink: "/coming-soon",
//     image: "assets/img-1/high-speed-transactions.png",
//   },
//   {
//     id: 1,
//     title: "High-speed Transactions",
//     description:
//       "OwnXChain facilitates high-speed transaction processing with an average TPS of 5000",
//     testnetLink: "/coming-soon",
//     mainnetLink: "/coming-soon",
//     image: "assets/img-1/high-speed-transactions.png",
//   },
//   {
//     id: 1,
//     title: "High-speed Transactions",
//     description:
//       "OwnXChain facilitates high-speed transaction processing with an average TPS of 5000",
//     testnetLink: "/coming-soon",
//     mainnetLink: "/coming-soon",
//     image: "assets/img-1/high-speed-transactions.png",
//   },
// ];

// export default function Slide() {
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     adaptiveHeight: true,
//   };

//   return (
//      <div className="whatwedo-wrapper">
//       <div className="slider-container">
//         <Slider {...settings}>
//           {slides.map((slide) => (
//             <div key={slide.id} className="slide-container">
//               <div className="slide-content d-flex flex-wrap align-items-center justify-content-between">

//                 <div className="text-section col-lg-5 col-md-6 col-12 pe-lg-5 pe-md-4 pe-0 mb-4 mb-md-0">
//                   <h4 className="clr-neutral-90 animate-line-3d">{slide.title}</h4>
//                   <p className="clr-neutral-80">{slide.description}</p>
//                   <div className="button-group fadein_bottom_7 mt-4 d-flex flex-wrap gap-4">
//                     <a href={slide.testnetLink} className="blue-btn">
//                       <span className="d-inline-block">Testnet</span>
//                       <span className="d-inline-block">
//                         <i className="bi bi-arrow-up-right" />
//                       </span>
//                     </a>
//                     <a href={slide.mainnetLink} className="blue-btn">
//                       <span className="d-inline-block">Mainnet</span>
//                       <span className="d-inline-block">
//                         <i className="bi bi-arrow-up-right" />
//                       </span>
//                     </a>
//                   </div>
//                 </div>

//                 <div className="image-section col-lg-6 col-md-6 col-12 d-flex justify-content-center">
//                   <img
//                     src={slide.image}
//                     alt={slide.title}
//                     className="img-fluid rounded-1 parallax-image"
//                   />
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// }

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const slides = [
  {
    id: 1,
    title: "High-speed Transactions",
    description:
      "Zenochain  facilitates high-speed transaction processing with an average TPS of 5000",
    buttons: [
      { text: "Testnet", link: "/" },
      { text: "Mainnet", link: "/" },
    ],
    image: "assets/img-1/high-speed-transactions (1).png",
  },
  {
    id: 2,
    title: "Modular Architecture",
    description:
      "Development of Zenochain  is carried out with modularity at core.",
    buttons: [
      {
        text: "Read More",
        link: "/",
      },
    ],
    image: "assets/img-1/modular-architecture (1).png",
  },
  {
    id: 3,
    title: "Proof-of-Alliance (PoA) Consensus",
    description:
      "Proposing the novel consensus mechanism Proof-of-Alliance (PoA) to upscale network security.",
    buttons: [{ text: "Read More", link: "/" }],
    image: "assets/img-1/proof-of-alliance (1).png",
  },
  {
    id: 4,
    title: "Cost Minimalized",
    description:
      "Transactions at a fraction of a cent",
    buttons: [
      { text: "Go to wallet", link: "/" },

    ],
    image: "assets/img-1/cost-minimalized (1).png",
  },
  {
    id: 5,
    title: "Decentralized & Proven Scalability",
    description:
      " More users = higher throughput",
    buttons: [
      { text: "Join", link: "/" },
    ],
    image: "assets/img-1/decentralized-proven-scalability.png",
  },
];

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next  " onClick={onClick} style={{ marginRight: "-30px" }}>
      < FaArrowAltCircleRight />

    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick} style={{ marginLeft: "-30px" }}>
      < FaArrowAltCircleLeft />
    </div>
  );
};
export default function slider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  return (
    <div className="whatwedo-wrapper">
      <div className="slider-container  ">
        <Slider {...settings}>
          {slides.map((slide) => (
            <div key={slide.id} className="slide-container">
              <div className="slide-layout">
                <div className="slide-left">
                  <h4 className="clr-neutral-90 animate-line-3d">{slide.title}</h4>
                  <p className="clr-neutral-80 animate-text-from-right">{slide.description}</p>
                  <div className="button-group  fadein_bottom_7">
                    {slide.buttons.map((btn, idx) => (
                      <a
                        key={idx}
                        href={btn.link}
                        target={btn.link.startsWith("http") ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className="modern-btn"
                      >
                        {btn.text} <i className="bi bi-arrow-up-right" />
                      </a>
                    ))}
                  </div>
                </div>
                <div className="slide-right">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="img-fluid  parallax-image"
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
